/* global window */
/* global document */
import { Fragment, useContext, useEffect } from 'react'
import { withRouter } from 'react-router'
import { Header, Sider, BreadCrumb } from 'components'
import { BackTop, Layout, Drawer } from 'antd'
import { config } from 'utils'
import styles from './PrimaryLayout.module.scss';
import { changeTheme, RouterContext, setSidebar, currentActiveMenuItem, pendingMenuItem } from 'components-contexts/RouterContext'
import { MenuList } from 'client/components/doctors/sidebar/SideMenuList';
import { DoctorMessaging } from 'config/routersConstants'
const { Content } = Layout

const DoctorLayout = (props) => {
  const { children, isMobile, isAuthenticated, account } = props;
  const { state, dispatch } = useContext(RouterContext)
  const { collapsed, theme } = state;
  useEffect(() => {
    dispatch(currentActiveMenuItem(props?.location?.pathname))
  }, [])

  const onCollapseChange = collapsed => {
    dispatch(setSidebar(collapsed));
  }

  const onChangeCurrentMenu = (activeMenu) => {
    if (state?.currentActiveMenu == DoctorMessaging.path) {
      dispatch(pendingMenuItem(activeMenu))
    }
    else {
      dispatch(currentActiveMenuItem(activeMenu))
    }
  }

  const headerProps = {
    theme,
    menus: MenuList,
    collapsed,
    notifications: null,
    onCollapseChange,
    fixed: config.fixedHeader,
    isMobile,
    onAllNotificationsRead() {
      // dispatch({ type: 'app/allNotificationsRead' })
    },
  }

  const siderProps = {
    theme,
    menus: MenuList,
    isMobile,
    collapsed,
    onCollapseChange,
    isAuthenticated,
    account,
    onThemeChange(theme) {
      dispatch(changeTheme(theme))
    },
    onChangeCurrentMenu,
    currentMenus:state?.currentActiveMenu,
    setCurrentFlg :state?.currentActiveMenu == DoctorMessaging.path ? true : false
  }

  return (
    <Fragment>
      <Layout hasSider={true}>
        {(isAuthenticated || isMobile) && <>
         {isMobile ? (
            <Drawer
              width={256}
              maskClosable
              closable={false}
              onClose={() => {onCollapseChange(!collapsed)}}
              visible={!collapsed}
              placement="left"
              style={{
                padding: 0,
                height: '100vh',
              }}
            >
              <Sider {...siderProps} collapsed={false} />
            </Drawer>
          ) : (
            <Sider {...siderProps} />
          )}
          </>}
        <div
          className={styles.container}
          style={{ paddingTop: config.fixedHeader ? 52 : 0 }}
          id="primaryLayout"
        >
          <Header {...headerProps} />
          <Content className={styles.content}>
            {/* <Bread routeList={newRouteList} /> */}

            {isAuthenticated && <BreadCrumb />}
            {/* {hasPermission ? children : <div>fdfgdf</div> } */}
            {children}
          </Content>
          <BackTop
            className={styles.backTop}
          // target={() => document.querySelector('#primaryLayout')}
          />
          {/* <GlobalFooter
              className={styles.footer}
              copyright={config.copyright}
            /> */}
        </div>
      </Layout>
    </Fragment>
  )

}

export default withRouter(DoctorLayout)

